class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderSectionHtml(html, url, event);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const entry = FacetFiltersForm.filterData.find(filterDataUrl);
    FacetFiltersForm.renderSectionHtml(entry.html, entry.url, event);
  }

  // Speed (2026-10-22): with no filter chosen the section comes back without filter options
  // ("+ Filters" button). If the visitor already opened the filters, take them from ?view=filters
  // so the options and counts stay right.
  static renderSectionHtml(html, url, event) {
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (PWFilters.isFull() && html.indexOf('data-pw-filters="lazy"') !== -1) {
      const query = url.indexOf('?') === -1 ? '' : url.slice(url.indexOf('?') + 1);
      PWFilters.fetchHtml(query).then((filtersHtml) => FacetFiltersForm.renderFilters(filtersHtml, event));
    } else {
      FacetFiltersForm.renderFilters(html, event);
    }
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    // 2026-10-23: filters with one option are left out, so the list of filters can change after
    // a choice. When both the page and the new HTML have the full panel, swap the whole panel
    // and keep the open dropdown open.
    if (PWFilters.isFull() && parsedHTML.querySelector('.facets-container[data-pw-filters="full"]')) {
      PWFilters.replacePanel(parsedHTML, true);
      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);
      return;
    }

    const facetDetailsElements =
      parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter');
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
      if (target) target.innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const searchParams = new URLSearchParams(formData).toString();
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
      form.onActiveFilterClick(event);
    });
  }
}

customElements.define('facet-remove', FacetRemove);

/*
 * Speed (2026-10-22): filters on demand.
 * Collection pages with no filter chosen are printed without the filter options (they were
 * ~840 KB on big collections). "+ Filters" (computers) or "Filter and sort" (phones) loads
 * them from the same address with ?view=filters (templates/collection.filters.liquid).
 */
const PWFilters = {
  loading: null,
  cache: {},

  container() {
    return document.querySelector('.facets-container[data-pw-filters]');
  },

  isFull() {
    const container = PWFilters.container();
    return !container || container.dataset.pwFilters === 'full';
  },

  fetchHtml(query) {
    const params = new URLSearchParams(query);
    params.delete('section_id');
    params.delete('page');
    params.set('view', 'filters');
    const url = `${window.location.pathname}?${params.toString()}`;
    if (PWFilters.cache[url]) return Promise.resolve(PWFilters.cache[url]);
    return fetch(url).then((response) => {
      if (!response.ok) throw new Error(`filters ${response.status}`);
      return response.text();
    }).then((html) => {
      PWFilters.cache[url] = html;
      return html;
    });
  },

  load() {
    if (PWFilters.isFull()) return Promise.resolve(true);
    if (PWFilters.loading) return PWFilters.loading;
    const buttons = document.querySelectorAll('.pw-filters-open');
    buttons.forEach((button) => { button.disabled = true; button.textContent = 'Loading filters...'; });
    PWFilters.loading = PWFilters.fetchHtml(window.location.search.slice(1))
      .then((html) => {
        PWFilters.apply(html);
        return true;
      })
      .catch(() => {
        buttons.forEach((button) => { button.disabled = false; button.textContent = '+ Filters (try again)'; });
        return false;
      })
      .finally(() => { PWFilters.loading = null; });
    return PWFilters.loading;
  },

  apply(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const container = PWFilters.container();
    PWFilters.replacePanel(parsed, false);
    if (container) container.dataset.pwFilters = 'full';
  },

  // Puts the filter lists from parsed HTML into the page (computer row and phone drawer).
  replacePanel(parsed, keepOpen) {
    const desktop = document.getElementById('FacetsWrapperDesktop');
    const desktopSource = parsed.getElementById('FacetsWrapperDesktop');
    if (desktop && desktopSource) {
      const open = keepOpen ? Array.from(desktop.querySelectorAll('details[open]'), (d) => d.dataset.index) : [];
      desktop.innerHTML = desktopSource.innerHTML;
      open.forEach((index) => {
        const details = desktop.querySelector(`details[data-index="${index}"]`);
        if (details) details.setAttribute('open', '');
      });
    }

    const mobile = document.querySelector('#FacetFiltersFormMobile .mobile-facets__main');
    const mobileSource = parsed.querySelector('#FacetFiltersFormMobile .mobile-facets__main');
    if (mobile && mobileSource) {
      const open = keepOpen ? Array.from(mobile.querySelectorAll('details[open]'), (d) => d.dataset.index) : [];
      mobile.innerHTML = mobileSource.innerHTML;
      const drawer = mobile.closest('menu-drawer');
      if (drawer) {
        mobile.querySelectorAll('summary').forEach((summary) => {
          summary.setAttribute('role', 'button');
          summary.setAttribute('aria-expanded', false);
          summary.addEventListener('click', drawer.onSummaryClick.bind(drawer));
        });
        mobile.querySelectorAll('button').forEach((button) => button.addEventListener('click', drawer.onCloseButtonClick.bind(drawer)));
      }
      open.forEach((index) => {
        const details = mobile.querySelector(`details[data-index="${index}"]`);
        if (details) {
          details.setAttribute('open', '');
          details.classList.add('menu-opening');
        }
      });
    }
  }
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('.pw-filters-open');
  if (button) {
    event.preventDefault();
    PWFilters.load();
    PWCollectionSearch.show(true);
    return;
  }

  // Phones: "Filter and sort" loads the filters first, then opens the drawer.
  const opener = event.target.closest('.mobile-facets__open-wrapper');
  if (!opener || PWFilters.isFull() || PWFilters.skipNext) {
    PWFilters.skipNext = false;
    return;
  }
  event.preventDefault();
  event.stopPropagation();
  PWCollectionSearch.show(false);
  PWFilters.load().then(() => {
    PWFilters.skipNext = true;
    opener.click();
  });
}, true);

/*
 * Search inside a collection (2026-10-23).
 * "Filter & Search" shows a search box above the products. The first search loads the
 * collection's product list (title, link, photo, type) from ?view=search-index, 250 products
 * per request, and keeps it for the visit. Every word typed must appear in the title or the
 * product type. Very big collections (over 15,000, like /collections/all) use the site search.
 */
const PWCollectionSearch = {
  MAX_INDEX: 15000,
  PAGE_SIZE: 60,
  items: null,
  loading: null,
  matches: [],
  shown: 0,

  root() {
    return document.getElementById('PWCollectionSearch');
  },

  show(focus) {
    const root = PWCollectionSearch.root();
    if (!root) return;
    root.hidden = false;
    if (focus) {
      const input = root.querySelector('.pw-search__input');
      if (input) input.focus();
    }
  },

  normalize(text) {
    return String(text || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  },

  cacheKey() {
    return `pw-search:${window.location.pathname}`;
  },

  loadIndex(onProgress) {
    if (PWCollectionSearch.items) return Promise.resolve(PWCollectionSearch.items);
    if (PWCollectionSearch.loading) return PWCollectionSearch.loading;
    try {
      const saved = sessionStorage.getItem(PWCollectionSearch.cacheKey());
      if (saved) {
        PWCollectionSearch.items = JSON.parse(saved);
        return Promise.resolve(PWCollectionSearch.items);
      }
    } catch (e) {}

    const getPage = (page) => fetch(`${window.location.pathname}?view=search-index&page=${page}`)
      .then((response) => {
        if (!response.ok) throw new Error(`search-index ${response.status}`);
        return response.json();
      });

    PWCollectionSearch.loading = getPage(1).then((first) => {
      const pages = Math.max(1, first.pages || 1);
      const results = [first.items];
      let done = 1;
      onProgress(done, pages);
      let next = 2;
      const worker = () => {
        if (next > pages) return Promise.resolve();
        const page = next++;
        return getPage(page).then((data) => {
          results[page - 1] = data.items;
          done += 1;
          onProgress(done, pages);
          return worker();
        });
      };
      const workers = [];
      for (let i = 0; i < 4; i++) workers.push(worker());
      return Promise.all(workers).then(() => {
        const items = [].concat(...results.filter(Boolean)).map((item) => ({
          title: item[0], url: item[1], img: item[2], type: item[3],
          text: PWCollectionSearch.normalize(`${item[0]} ${item[3]}`)
        }));
        PWCollectionSearch.items = items;
        try {
          sessionStorage.setItem(PWCollectionSearch.cacheKey(), JSON.stringify(items));
        } catch (e) {}
        return items;
      });
    }).finally(() => { PWCollectionSearch.loading = null; });
    return PWCollectionSearch.loading;
  },

  setStatus(text) {
    const status = PWCollectionSearch.root().querySelector('.pw-search__status');
    if (status) status.textContent = text;
  },

  run(query) {
    const root = PWCollectionSearch.root();
    if (!root) return;
    root.hidden = false;
    const input = root.querySelector('.pw-search__input');
    if (input && input.value !== query) input.value = query;
    const words = PWCollectionSearch.normalize(query).split(' ').filter(Boolean);
    if (!words.length) {
      PWCollectionSearch.clear();
      return;
    }

    const count = Number(root.dataset.count || 0);
    if (count > PWCollectionSearch.MAX_INDEX) {
      window.location.href = `/search?q=${encodeURIComponent(query)}&options%5Bprefix%5D=last&options%5Bfields%5D=title%2Cproduct_type%2Ctag`;
      return;
    }

    PWCollectionSearch.setStatus('Searching...');
    PWCollectionSearch.loadIndex((done, pages) => {
      if (pages > 1) PWCollectionSearch.setStatus(`Loading the products of this collection... ${Math.round((done / pages) * 100)}%`);
    }).then((items) => {
      PWCollectionSearch.matches = items.filter((item) => words.every((word) => item.text.indexOf(word) !== -1));
      PWCollectionSearch.shown = 0;
      root.querySelector('.pw-search__grid').innerHTML = '';
      const total = PWCollectionSearch.matches.length;
      PWCollectionSearch.setStatus(total === 0
        ? `No products in ${root.dataset.title} match "${query}".`
        : `${total.toLocaleString()} product${total === 1 ? '' : 's'} in ${root.dataset.title} match "${query}".`);
      PWCollectionSearch.renderMore();
      root.querySelector('.pw-search__clear').hidden = false;
      const grid = document.getElementById('ProductGridContainer');
      if (grid) grid.hidden = true;
    }).catch(() => {
      PWCollectionSearch.setStatus('The search could not load. Please try again.');
    });
  },

  renderMore() {
    const root = PWCollectionSearch.root();
    const grid = root.querySelector('.pw-search__grid');
    const slice = PWCollectionSearch.matches.slice(PWCollectionSearch.shown, PWCollectionSearch.shown + PWCollectionSearch.PAGE_SIZE);
    const escapeHtml = (text) => String(text || '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
    grid.insertAdjacentHTML('beforeend', slice.map((item) => `<li><a href="${escapeHtml(item.url)}"><span class="pw-search__media">${item.img
      ? `<img src="${escapeHtml(item.img)}" alt="${escapeHtml(item.title)}" loading="lazy" width="300" height="300">`
      : ''}</span><span class="pw-search__title">${escapeHtml(item.title)}</span></a></li>`).join(''));
    PWCollectionSearch.shown += slice.length;
    root.querySelector('.pw-search__more').hidden = PWCollectionSearch.shown >= PWCollectionSearch.matches.length;
  },

  clear() {
    const root = PWCollectionSearch.root();
    if (!root) return;
    root.querySelector('.pw-search__grid').innerHTML = '';
    root.querySelector('.pw-search__more').hidden = true;
    root.querySelector('.pw-search__clear').hidden = true;
    root.querySelectorAll('.pw-search__input').forEach((input) => { input.value = ''; });
    const mobileInput = document.getElementById('PWSearchMobile');
    if (mobileInput) mobileInput.value = '';
    PWCollectionSearch.setStatus('');
    const grid = document.getElementById('ProductGridContainer');
    if (grid) grid.hidden = false;
  }
};

(function () {
  const root = PWCollectionSearch.root();
  if (!root) return;
  root.querySelector('.pw-search__form').addEventListener('submit', (event) => {
    event.preventDefault();
    PWCollectionSearch.run(root.querySelector('.pw-search__input').value);
  });
  root.querySelector('.pw-search__clear').addEventListener('click', () => PWCollectionSearch.clear());
  root.querySelector('.pw-search__more').addEventListener('click', () => PWCollectionSearch.renderMore());

  // Phone drawer box: keep its typing away from the filter form, search on Enter or "Search".
  const runMobile = () => {
    const input = document.getElementById('PWSearchMobile');
    if (!input) return;
    const drawerSummary = document.querySelector('.mobile-facets__disclosure > summary');
    const details = input.closest('details');
    if (drawerSummary && details && details.hasAttribute('open')) drawerSummary.click();
    PWCollectionSearch.run(input.value);
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  document.addEventListener('input', (event) => {
    if (event.target.id === 'PWSearchMobile') event.stopPropagation();
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.target.id === 'PWSearchMobile' && event.key === 'Enter') {
      event.preventDefault();
      runMobile();
    }
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.pw-search-mobile__go')) {
      event.preventDefault();
      event.stopPropagation();
      runMobile();
    }
  }, true);
})();

/*
 * Full Line and Series lists (2026-10-25).
 * Shopify lists at most 100 options per filter. On a full Line or Series filter, "Show all ...
 * options" reads the collection (with the other chosen filters) from ?view=facet-values,
 * 250 products per request, counts every value and adds the missing ones to the list, sorted
 * A-Z with the others. A list that was opened this way opens again after each filter change.
 */
const PWAllValues = {
  cache: {},
  expanded: new Set(),

  key(param) {
    return param.slice(param.lastIndexOf('.') + 1); // filter.p.m.my_fields.line -> line
  },

  query(param) {
    const params = new URLSearchParams(window.location.search);
    params.delete(param);
    params.delete('page');
    params.delete('section_id');
    params.delete('view');
    return params;
  },

  count(param) {
    const params = PWAllValues.query(param);
    const cacheKey = `${param}?${params.toString()}`;
    if (PWAllValues.cache[cacheKey]) return Promise.resolve(PWAllValues.cache[cacheKey]);
    const column = PWAllValues.key(param) === 'series' ? 1 : 0;
    const getPage = (page) => {
      const p = new URLSearchParams(params);
      p.set('view', 'facet-values');
      p.set('page', page);
      return fetch(`${window.location.pathname}?${p.toString()}`).then((response) => {
        if (!response.ok) throw new Error(`facet-values ${response.status}`);
        return response.json();
      });
    };
    return getPage(1).then((first) => {
      const pages = Math.max(1, first.pages || 1);
      const results = [first.items];
      let next = 2;
      const worker = () => {
        if (next > pages) return Promise.resolve();
        const page = next++;
        return getPage(page).then((data) => { results[page - 1] = data.items; return worker(); });
      };
      const workers = [];
      for (let i = 0; i < 4; i++) workers.push(worker());
      return Promise.all(workers).then(() => {
        const counts = new Map();
        results.forEach((items) => (items || []).forEach((item) => {
          let values = item[column];
          if (values === null || values === undefined || values === '') return;
          if (!Array.isArray(values)) values = [values];
          new Set(values).forEach((value) => counts.set(value, (counts.get(value) || 0) + 1));
        }));
        PWAllValues.cache[cacheKey] = counts;
        return counts;
      });
    });
  },

  expand(button) {
    const box = button.closest('.pw-all-values');
    const list = box && box.parentElement.querySelector('ul');
    if (!list) return;
    const param = button.dataset.param;
    const status = box.querySelector('.pw-all-values__status');
    button.hidden = true;
    status.textContent = 'Loading all options...';
    PWAllValues.count(param).then((counts) => {
      const sample = list.querySelector('li');
      if (!sample) return;
      const shown = new Set(Array.from(list.querySelectorAll('input'), (input) => input.value));
      const active = new Set(new URLSearchParams(window.location.search).getAll(param));
      let added = 0;
      counts.forEach((count, value) => {
        if (shown.has(value)) return;
        const item = sample.cloneNode(true);
        const input = item.querySelector('input');
        const label = item.querySelector('label');
        const id = `${input.id.replace(/-\d+$/, '')}-all-${added}`;
        input.id = id;
        input.value = value;
        input.checked = active.has(value);
        input.disabled = false;
        label.setAttribute('for', id);
        label.classList.remove('facet-checkbox--disabled', 'mobile-facets__label--disabled');
        const text = Array.from(label.childNodes).filter((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
        const node = text.length ? text[text.length - 1] : label.appendChild(document.createTextNode(''));
        node.textContent = ` ${value} (${count}) `;
        list.appendChild(item);
        added += 1;
      });
      const labelText = (li) => (li.querySelector('label').textContent || '').trim().toLowerCase();
      Array.from(list.children).sort((a, b) => labelText(a).localeCompare(labelText(b))).forEach((li) => list.appendChild(li));
      PWAllValues.expanded.add(param);
      const total = list.querySelectorAll('li').length;
      status.textContent = `Showing all ${total} options.`;
    }).catch(() => {
      button.hidden = false;
      status.textContent = 'Could not load all options. Please try again.';
    });
  },

  // After a filter change the panel is rebuilt from the server; open the full lists again.
  restore() {
    if (!PWAllValues.expanded.size) return;
    document.querySelectorAll('.pw-all-values__button').forEach((button) => {
      if (PWAllValues.expanded.has(button.dataset.param) && !button.hidden) PWAllValues.expand(button);
    });
  }
};

document.addEventListener('click', (event) => {
  const button = event.target.closest('.pw-all-values__button');
  if (!button) return;
  event.preventDefault();
  event.stopPropagation();
  PWAllValues.expand(button);
}, true);

new MutationObserver(() => {
  clearTimeout(PWAllValues.timer);
  PWAllValues.timer = setTimeout(PWAllValues.restore, 50);
}).observe(document.body, { childList: true, subtree: true });
